module.exports = __webpack_public_path__ + "static/media/pay-stripe-on.bc2c2383.png";